import React from "react";

const ScrollableListItem = ({ filterName, filterValue }) => {
  return (
    <div className="scrollable-list-item" style={{gap: "var(--space-medium)"}}>
      <span className="filter-name type-body-bold-medium">{filterName}:</span>
      <div className="filter-value">
        {filterValue.map((value) => {
          return (
            <p key={value}>
              {value}
              <br />
            </p>
          );
        })}
      </div>
    </div>
  );
};

export default ScrollableListItem;
